module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.992 33.813\"><defs><style>.a-light{fill:none;stroke:#E3E3E3;stroke-width:3px;}</style></defs><path class=\"a-light\" d=\"M-9988.408,3284.656l16.191-22.79,16.736,24.485h-27.5l10.766-15.458,14.71,20.662h-27.548\" transform=\"translate(-9952.639 3293.055) rotate(180)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/components/svgs/gr_logo_light.svg
// module id = LHA2
// module chunks = 1